import { unreadMessageCountApi, getCourseApi } from '@/api/index'
import { getToken } from '@/utils/auth'

const message = {
  state: {
    messageInfo: JSON.parse(sessionStorage.getItem('messageInfo')) || null,
    notice: true,
    unreadMessageCount: 0, // 未读消息数量
    bookUnreadMessageCount: 0
  },
  mutations: {
    setMessageInfo(state, info) {
      state.messageInfo = info;
      sessionStorage.setItem('messageInfo', JSON.stringify(info));
    },
    setNoticeDisplay(state, status) {
      state.notice = status;
    },
    setUnreadMessageCount(state, count) {
      state.unreadMessageCount = count
    },
    setBookUnreadMessageCount(state, count) {
      state.bookUnreadMessageCount = count
    }
  },
  actions: {
    // 获取未读消息数量
    getUnreadMessageCount({ commit, rootState }) {
      if (!getToken()) return;
      const params = {
        source: rootState.user.platform
      }
      return unreadMessageCountApi(params).then(res => {
        const bookCount = res.data || 0
        commit('setBookUnreadMessageCount', bookCount)
        getCourseApi({
          key: 'url',
          value: '/message/unread/count'
        }).then(courseRes => {
          const totalCount = courseRes.data || 0
          commit('setUnreadMessageCount', totalCount)
        })
      })
    }
  },
};

export default message
